function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import _formatMuiErrorMessage from "@mui/utils/formatMuiErrorMessage";
/**
 * For using in `sx` prop to sort the breakpoint from low to high.
 * Note: this function does not work and will not support multiple units.
 *       e.g. input: { '@container (min-width:300px)': '1rem', '@container (min-width:40rem)': '2rem' }
 *            output: { '@container (min-width:40rem)': '2rem', '@container (min-width:300px)': '1rem' } // since 40 < 300 eventhough 40rem > 300px
 */
export function sortContainerQueries(theme, css) {
  if (!theme.containerQueries) {
    return css;
  }
  var sorted = Object.keys(css).filter(function (key) {
    return key.startsWith('@container');
  }).sort(function (a, b) {
    var _a$match, _b$match;
    var regex = /min-width:\s*([0-9.]+)/;
    return +(((_a$match = a.match(regex)) === null || _a$match === void 0 ? void 0 : _a$match[1]) || 0) - +(((_b$match = b.match(regex)) === null || _b$match === void 0 ? void 0 : _b$match[1]) || 0);
  });
  if (!sorted.length) {
    return css;
  }
  return sorted.reduce(function (acc, key) {
    var value = css[key];
    delete acc[key];
    acc[key] = value;
    return acc;
  }, _objectSpread({}, css));
}
export function isCqShorthand(breakpointKeys, value) {
  return value === '@' || value.startsWith('@') && (breakpointKeys.some(function (key) {
    return value.startsWith("@".concat(key));
  }) || !!value.match(/^@\d/));
}
export function getContainerQuery(theme, shorthand) {
  var matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
  if (!matches) {
    if (process.env.NODE_ENV !== 'production') {
      throw new Error(process.env.NODE_ENV !== "production" ? "MUI: The provided shorthand ".concat("(".concat(shorthand, ")"), " is invalid. The format should be `@<breakpoint | number>` or `@<breakpoint | number>/<container>`.\n") + 'For example, `@sm` or `@600` or `@40rem/sidebar`.' : _formatMuiErrorMessage(18, "(".concat(shorthand, ")")));
    }
    return null;
  }
  var _matches = _slicedToArray(matches, 3),
    containerQuery = _matches[1],
    containerName = _matches[2];
  var value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
  return theme.containerQueries(containerName).up(value);
}
export default function cssContainerQueries(themeInput) {
  var toContainerQuery = function toContainerQuery(mediaQuery, name) {
    return mediaQuery.replace('@media', name ? "@container ".concat(name) : '@container');
  };
  function attachCq(node, name) {
    node.up = function () {
      var _themeInput$breakpoin;
      return toContainerQuery((_themeInput$breakpoin = themeInput.breakpoints).up.apply(_themeInput$breakpoin, arguments), name);
    };
    node.down = function () {
      var _themeInput$breakpoin2;
      return toContainerQuery((_themeInput$breakpoin2 = themeInput.breakpoints).down.apply(_themeInput$breakpoin2, arguments), name);
    };
    node.between = function () {
      var _themeInput$breakpoin3;
      return toContainerQuery((_themeInput$breakpoin3 = themeInput.breakpoints).between.apply(_themeInput$breakpoin3, arguments), name);
    };
    node.only = function () {
      var _themeInput$breakpoin4;
      return toContainerQuery((_themeInput$breakpoin4 = themeInput.breakpoints).only.apply(_themeInput$breakpoin4, arguments), name);
    };
    node.not = function () {
      var _themeInput$breakpoin5;
      var result = toContainerQuery((_themeInput$breakpoin5 = themeInput.breakpoints).not.apply(_themeInput$breakpoin5, arguments), name);
      if (result.includes('not all and')) {
        // `@container` does not work with `not all and`, so need to invert the logic
        return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
      }
      return result;
    };
  }
  var node = {};
  var containerQueries = function containerQueries(name) {
    attachCq(node, name);
    return node;
  };
  attachCq(containerQueries);
  return _objectSpread(_objectSpread({}, themeInput), {}, {
    containerQueries: containerQueries
  });
}